import {
  type AdvancedFilterTableColumnDefinition,
  createDeviceFilter,
  createIpFilter,
  createTextFilter,
  createUptimeFilter,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useApiTableContextSelectors } from 'components/ApiTable/model/ApiTableModel';
import { isBackendColumn } from 'components/Table/model/isBackendColumn';
import { useMemo } from 'react';

const getDeviceColumns = (
  allowedProperties?: string[],
): AdvancedFilterTableColumnDefinition<any>[] =>
  [
    {
      key: 'device.slug',
      title: 'Device > API Slug',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.vendor',
      title: 'Device > Vendor',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.family',
      title: 'Device > Family',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.model',
      title: 'Device > Model',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.platform',
      title: 'Device > Platform',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.version',
      title: 'Device > Version',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.image',
      title: 'Device > Image',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.devType',
      title: 'Device > Type',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.loginIp',
      title: 'Device > Login IP',
      filter: createDeviceFilter(createIpFilter),
    },
    {
      key: 'device.domain',
      title: 'Device > Domain',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.attributes',
      title: 'Device > Attribute',
      filter: createDeviceFilter(createTextFilter),
    },
    {
      key: 'device.uptime',
      title: 'Device > Uptime',
      filter: createDeviceFilter(createUptimeFilter),
    },
  ].filter((column) =>
    allowedProperties ? allowedProperties.includes(column.key) : true,
  );

export const useApiTableAdvancedFilterColumns =
  (): AdvancedFilterTableColumnDefinition<any>[] => {
    const { endpoint } = useApiTableContextSelectors({
      endpoint: prop('endpoint'),
    });
    const { columns, deviceFilters } = endpoint;

    return useMemo(
      () => [
        ...columns.filter(isBackendColumn),
        ...(deviceFilters.enabled
          ? getDeviceColumns(deviceFilters.properties)
          : []),
      ],
      [columns, deviceFilters],
    );
  };
